/* import __COLOCATED_TEMPLATE__ from './event-timeline.hbs.js'; */
var _dec, _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';

/**
## Timeline

It displays the current status, call to action and a series of timeline events.

#### Contextual components

| Contextual Name     | Component                                               |
|---------------------|---------------------------------------------------------|
| timeline.status     | [event-timeline/status](/components/glass/event-timeline/status.html) |
| timeline.item       | [event-timeline/item](/components/glass/event-timeline/item.html)     |

@param {Boolean} showViewAllButton - if true there will be a viewAll button under the events
@param {Action} viewAllAction - action for the viewAll button if viewAll button is showing
@param {String} viewAllText - text for the viewAll button if it's showing

Style dependencies: `dashboard/components/_event-timeline.scss`

 */
let EventTimeline = (_dec = classNames('event-timeline'), _dec(_class = class EventTimeline extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "showViewAllButton", false);
    _defineProperty(this, "viewAllAction", null);
    _defineProperty(this, "viewAllText", null);
  }
}) || _class);
export { EventTimeline as default };